"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineItems = void 0;
/**
 * 各種工事の一覧データ
 */
exports.lineItems = [
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝10㎝',
        unit: 'ｍ',
        price: 250,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝10㎝',
        unit: 'ｍ',
        price: 320,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝15㎝',
        unit: 'ｍ',
        price: 260,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝15㎝',
        unit: 'ｍ',
        price: 330,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝20㎝',
        unit: 'ｍ',
        price: 290,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝20㎝',
        unit: 'ｍ',
        price: 380,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝30㎝',
        unit: 'ｍ',
        price: 460,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝30㎝',
        unit: 'ｍ',
        price: 590,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝45㎝',
        unit: 'ｍ',
        price: 600,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝45㎝',
        unit: 'ｍ',
        price: 800,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝10㎝',
        unit: 'ｍ',
        price: 250,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝10㎝',
        unit: 'ｍ',
        price: 320,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝15㎝',
        unit: 'ｍ',
        price: 260,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝15㎝',
        unit: 'ｍ',
        price: 330,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝20㎝',
        unit: 'ｍ',
        price: 290,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝20㎝',
        unit: 'ｍ',
        price: 380,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝30㎝',
        unit: 'ｍ',
        price: 460,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝30㎝',
        unit: 'ｍ',
        price: 590,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝45㎝',
        unit: 'ｍ',
        price: 600,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝45㎝',
        unit: 'ｍ',
        price: 800,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・記号・文字　15㎝換算　溶解式（白）',
        unit: 'ｍ',
        price: 570,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・記号・文字　15㎝換算　溶解式（黄）',
        unit: 'ｍ',
        price: 650,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '身障者マーク　溶解式(白)1500×1000',
        unit: '箇所',
        price: 10000,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '身障者マーク　溶解式(白)1500×1000ゼブラ有',
        unit: '箇所',
        price: 15000,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・直進　溶解式(白)　2.0ｍ',
        unit: '箇所',
        price: 2500,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・直進　溶解式(白)　5.0ｍ',
        unit: '箇所',
        price: 3500,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・左折or右折　溶解式(白)　5.0ｍ',
        unit: '箇所',
        price: 4000,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・直右左折　溶解式(白)　5.0ｍ',
        unit: '箇所',
        price: 5500,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '番号　シート貼付式・焼付式　白　300*150',
        unit: '枚',
        price: 500,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '番号　シート貼付式・焼付式　黄　300*150',
        unit: '枚',
        price: 550,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '軽マーク　シート貼付式・焼付式　白　500*500',
        unit: '文字',
        price: 5500,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '軽マーク　シート貼付式・焼付式　黄　500*500',
        unit: '文字',
        price: 6000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1000以内　英数字',
        unit: '文字',
        price: 2000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1000以内　ひらがな・カタカナ',
        unit: '文字',
        price: 3000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1000以内　漢字',
        unit: '文字',
        price: 5000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1200以内　英数字',
        unit: '文字',
        price: 2500,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1200以内　ひらがな・カタカナ',
        unit: '文字',
        price: 4000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1200以内　漢字',
        unit: '文字',
        price: 6000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1500以内　英数字',
        unit: '文字',
        price: 3000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1500以内　ひらがな・カタカナ',
        unit: '文字',
        price: 5000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1500以内　漢字',
        unit: '文字',
        price: 7000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1800以内　英数字',
        unit: '文字',
        price: 3500,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1800以内　ひらがな・カタカナ',
        unit: '文字',
        price: 6000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1800以内　漢字',
        unit: '文字',
        price: 8000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□2000以内　英数字',
        unit: '文字',
        price: 4000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□2000以内　ひらがな・カタカナ',
        unit: '文字',
        price: 7000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□2000以内　漢字',
        unit: '文字',
        price: 9000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□2500以内　漢字',
        unit: '文字',
        price: 11000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1000以内　英数字',
        unit: '文字',
        price: 2400,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1000以内　ひらがな・カタカナ',
        unit: '文字',
        price: 3600,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1000以内　漢字',
        unit: '文字',
        price: 6000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1200以内　英数字',
        unit: '文字',
        price: 3000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1200以内　ひらがな・カタカナ',
        unit: '文字',
        price: 4800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1200以内　漢字',
        unit: '文字',
        price: 7200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1500以内　英数字',
        unit: '文字',
        price: 3600,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1500以内　ひらがな・カタカナ',
        unit: '文字',
        price: 6000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1500以内　漢字',
        unit: '文字',
        price: 8400,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1800以内　英数字',
        unit: '文字',
        price: 4200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1800以内　ひらがな・カタカナ',
        unit: '文字',
        price: 7200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1800以内　漢字',
        unit: '文字',
        price: 9600,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□2000以内　英数字',
        unit: '文字',
        price: 4800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□2000以内　ひらがな・カタカナ',
        unit: '文字',
        price: 8400,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□2000以内　漢字',
        unit: '文字',
        price: 10800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□2500以内　漢字',
        unit: '文字',
        price: 13200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '視覚障害者誘導標示',
        specification: '貼付式　300*300　ステップガイドHG',
        unit: '枚',
        price: 2800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: 'パーキングブロック',
        specification: '車止め設置　Ｈ100　コンクリート　アンカー式',
        unit: '本',
        price: 2300,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: 'パーキングブロック',
        specification: '車止め設置　Ｈ120　コンクリート　アンカー式',
        unit: '本',
        price: 2700,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: 'パーキングブロック',
        specification: '車止め設置　Ｈ110　樹脂　アンカー式',
        unit: '本',
        price: 2800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: 'パーキングブロック',
        specification: '車止め撤去(処分含む)',
        unit: '本',
        price: 1000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '消去',
        specification: '番号消去　300*150',
        unit: '文字',
        price: 300,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '密粒舗装',
        category: '消去',
        specification: '区画線消去　削り取り式 W150mm換算',
        unit: 'ｍ',
        price: 450,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝10㎝',
        unit: 'ｍ',
        price: 300,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝10㎝',
        unit: 'ｍ',
        price: 390,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝15㎝',
        unit: 'ｍ',
        price: 320,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝15㎝',
        unit: 'ｍ',
        price: 400,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝20㎝',
        unit: 'ｍ',
        price: 350,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝20㎝',
        unit: 'ｍ',
        price: 460,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝30㎝',
        unit: 'ｍ',
        price: 560,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝30㎝',
        unit: 'ｍ',
        price: 710,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(白)W＝45㎝',
        unit: 'ｍ',
        price: 720,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '実線',
        specification: '溶融式　(黄)W＝45㎝',
        unit: 'ｍ',
        price: 960,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝10㎝',
        unit: 'ｍ',
        price: 300,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝10㎝',
        unit: 'ｍ',
        price: 390,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝15㎝',
        unit: 'ｍ',
        price: 320,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝15㎝',
        unit: 'ｍ',
        price: 400,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝20㎝',
        unit: 'ｍ',
        price: 350,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝20㎝',
        unit: 'ｍ',
        price: 460,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝30㎝',
        unit: 'ｍ',
        price: 560,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝30㎝',
        unit: 'ｍ',
        price: 710,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(白)W＝45㎝',
        unit: 'ｍ',
        price: 720,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '破線',
        specification: '溶融式　(黄)W＝45㎝',
        unit: 'ｍ',
        price: 960,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・記号・文字　15㎝換算　溶解式（白）',
        unit: 'ｍ',
        price: 690,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・記号・文字　15㎝換算　溶解式（黄）',
        unit: 'ｍ',
        price: 780,
        whiteSet: false,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '身障者マーク　溶解式(白)1500×1000',
        unit: '箇所',
        price: 12000,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '身障者マーク　溶解式(白)1500×1000ゼブラ有',
        unit: '箇所',
        price: 18000,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・直進　溶解式(白)　2.0ｍ',
        unit: '箇所',
        price: 3000,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・直進　溶解式(白)　5.0ｍ',
        unit: '箇所',
        price: 4200,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・左折or右折　溶解式(白)　5.0ｍ',
        unit: '箇所',
        price: 4800,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '矢印・直右左折　溶解式(白)　5.0ｍ',
        unit: '箇所',
        price: 6600,
        whiteSet: true,
        whiteYellowSet: true
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1000以内　英数字',
        unit: '文字',
        price: 2400,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1000以内　ひらがな・カタカナ',
        unit: '文字',
        price: 3600,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1000以内　漢字',
        unit: '文字',
        price: 6000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1200以内　英数字',
        unit: '文字',
        price: 3000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1200以内　ひらがな・カタカナ',
        unit: '文字',
        price: 4800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1200以内　漢字',
        unit: '文字',
        price: 7200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1500以内　英数字',
        unit: '文字',
        price: 3600,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1500以内　ひらがな・カタカナ',
        unit: '文字',
        price: 6000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1500以内　漢字',
        unit: '文字',
        price: 8400,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1800以内　英数字',
        unit: '文字',
        price: 4200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1800以内　ひらがな・カタカナ',
        unit: '文字',
        price: 7200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□1800以内　漢字',
        unit: '文字',
        price: 9600,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□2000以内　英数字',
        unit: '文字',
        price: 4800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□2000以内　ひらがな・カタカナ',
        unit: '文字',
        price: 8400,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□2000以内　漢字',
        unit: '文字',
        price: 10800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(白)　□2500以内　漢字',
        unit: '文字',
        price: 13200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1000以内　英数字',
        unit: '文字',
        price: 2900,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1000以内　ひらがな・カタカナ',
        unit: '文字',
        price: 4400,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1000以内　漢字',
        unit: '文字',
        price: 7200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1200以内　英数字',
        unit: '文字',
        price: 3600,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1200以内　ひらがな・カタカナ',
        unit: '文字',
        price: 5800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1200以内　漢字',
        unit: '文字',
        price: 8700,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1500以内　英数字',
        unit: '文字',
        price: 4400,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1500以内　ひらがな・カタカナ',
        unit: '文字',
        price: 7200,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1500以内　漢字',
        unit: '文字',
        price: 10100,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1800以内　英数字',
        unit: '文字',
        price: 5100,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1800以内　ひらがな・カタカナ',
        unit: '文字',
        price: 8700,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□1800以内　漢字',
        unit: '文字',
        price: 11600,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□2000以内　英数字',
        unit: '文字',
        price: 5800,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□2000以内　ひらがな・カタカナ',
        unit: '文字',
        price: 10100,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□2000以内　漢字',
        unit: '文字',
        price: 13000,
        whiteSet: false,
        whiteYellowSet: false
    },
    {
        pavementType: '開粒舗装',
        category: '矢印・番号・文字・軽マーク・自転車',
        specification: '溶融式　文字(黄)　□2500以内　漢字',
        unit: '文字',
        price: 15900,
        whiteSet: false,
        whiteYellowSet: false
    }
];
